import React, { useState } from "react";
import withStyles from 'react-jss';
import Icon from "antd/lib/icon";
import Input from "antd/lib/input";
import { StylesProps } from "src/Library/Types";

const styles = themes => ({
  searchIcon: {
    fontSize: 16,
  },
});
 
interface ExpandableSearchInputProps extends StylesProps<ReturnType<typeof styles>> {
  value: string | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ExpandableSearchInput: React.FunctionComponent<ExpandableSearchInputProps> = ({
  classes,
  value,
  onChange,
}) => {
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  return isSearchExpanded ? (
    <Input
      allowClear
      suffix={!value?.length && (
          <Icon type="search" />
        )
      }
      placeholder={'Search'}
      value={value}
      onBlur={() => {
        if (!value?.length) {
          setIsSearchExpanded(false);
        }
      }}
      onChange={onChange}
    />
  ) : (
    <Icon
      className={classes.searchIcon}
      type="search"
      onClick={() => setIsSearchExpanded(true)}
    />
  );
}

export default withStyles(styles)(ExpandableSearchInput);